var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMountains41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3271 4.02126C14.1605 2.65958 16.129 2.65958 16.9624 4.02126L21.6911 11.5108C21.8929 11.8304 22 12.2006 22 12.5785V17.4604L19.9078 14.224C18.4752 12.0079 15.2421 12.0079 13.8095 14.224L13.7942 14.2477L11.9523 11.2382C10.5338 8.92059 7.17665 8.92059 5.75818 11.2382L2 17.3787V12.6123C2 12.2132 2.11936 11.8233 2.34274 11.4927L5.3519 7.03838C6.19353 5.73648 8.08917 5.73648 8.9308 7.03838L10.2406 9.06442L13.3271 4.02126Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6729 12.0213C9.8395 10.6596 7.87098 10.6596 7.03759 12.0213L2.31997 19.7294C2.16794 19.9778 2.0732 20.2386 2.02919 20.5H2C1.72386 20.5 1.5 20.7239 1.5 21C1.5 21.2761 1.72386 21.5 2 21.5H22C22.2761 21.5 22.5 21.2761 22.5 21C22.5 20.7239 22.2761 20.5 22 20.5H21.971C21.9244 20.2224 21.8205 19.9457 21.6517 19.6845L18.6481 15.0384C17.8065 13.7365 15.9109 13.7365 15.0692 15.0384L13.7595 17.0644L10.6729 12.0213Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains41);
export default __webpack_public_path__ + "static/media/mountains-4-1.aa6d3e3ec2fed4ba2a9ce05397e69bd9.svg";
export { ForwardRef as ReactComponent };